import { render, staticRenderFns } from "./TokenBookingDashboard.vue?vue&type=template&id=67881cf7&"
import script from "./TokenBookingDashboard.vue?vue&type=script&lang=js&"
export * from "./TokenBookingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TokenBookingDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports